import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.547",
    d: "M10.696 14.886a5.787 5.787 0 01-2.09.095 5.683 5.683 0 01-4.807-4.841 5.648 5.648 0 016.333-6.342 5.674 5.674 0 014.85 4.815 5.64 5.64 0 01-1.466 4.633 2.144 2.144 0 00.095 2.967l.99.99h1.735v1.734l1.301 1.302h2.603v-2.603l-4.286-4.286"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "1.5",
    d: "M8.75 10.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.547",
    d: "M10.696 14.886a5.787 5.787 0 01-2.09.095 5.683 5.683 0 01-4.807-4.841 5.648 5.648 0 016.333-6.342 5.674 5.674 0 014.85 4.815 5.64 5.64 0 01-1.466 4.633 2.144 2.144 0 00.095 2.967l.99.99h1.735v1.734l1.301 1.302h2.603v-2.603l-4.286-4.286"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "1.5",
    d: "M8.75 10.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3.094",
    d: "M21.393 29.771a11.561 11.561 0 01-4.182.191 11.366 11.366 0 01-9.613-9.682A11.296 11.296 0 0120.265 7.596a11.348 11.348 0 019.7 9.63 11.278 11.278 0 01-2.933 9.266 4.286 4.286 0 00.19 5.934l1.979 1.978h3.47v3.47l2.603 2.603h5.206v-5.205L31.908 26.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "bevel",
    strokeWidth: "3",
    d: "M17.5 21a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
  }))
};
export var FirstAccess = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});